<template>
  <div>

    <div class="card mb-3">
      <div class="card-header">
        <i class="fa fa-bar-chart"></i> {{ $t('dashboard.investment.title') }}

        <div class="float-right" >
          <a href="#filter" name="filter" v-on:click="expandOrCollapseFilter">
              <span class="fa fa-expand fa-lg" v-if="!filterVisible" ></span>
              <span class="fa fa-compress fa-lg" v-if="filterVisible"></span>
          </a>
        </div>
      </div>
      <div class="card-body" v-if="filterVisible">
        
        <div class="row">

          <div class="form-group col-md-4">
            <label>{{ $t('project.form.type') }}</label>
            <multiselect v-model="filter.investmentType" track-by="item1" label="item2"
              :options="investmentTypes" :multiple="true" :taggable="false"
              v-bind:placeholder="$t('project.form.type')" 
              v-bind:deselect-label="$t('multiselect.deselect-label')"
              v-bind:select-label="$t('multiselect.selectedLabel')">
            </multiselect>
          </div>

          <div class="form-group col-md-4">
            <label>{{ $t('address.form.region') }}</label>
            <multiselect v-model="filter.region" track-by="item1" label="item2"
              :options="regions" :multiple="true" :taggable="false"
              v-bind:placeholder="$t('address.form.region')" 
              v-bind:deselect-label="$t('multiselect.deselect-label')"
              v-bind:select-label="$t('multiselect.selectedLabel')">
            </multiselect>
          </div>

          <div class="form-group col-md-4">
            <label>{{ $t('project.investment.form.type') }}</label>
            <multiselect v-model="filter.types" track-by="item1" label="item2"
              :options="types" :multiple="true" :taggable="false"
              v-bind:placeholder="$t('project.investment.form.type')" 
              v-bind:deselect-label="$t('multiselect.deselect-label')"
              v-bind:select-label="$t('multiselect.selectedLabel')">
            </multiselect>
          </div>

        </div>
        <div class="row">

          <div class="form-group col-md-4">
            <label>{{ $t('project.investment.form.category') }}</label>
            <multiselect v-model="filter.category" track-by="item1" label="item2"
              :options="categorys" :multiple="true" :taggable="false"
              v-bind:placeholder="$t('project.investment.form.category')" 
              v-bind:deselect-label="$t('multiselect.deselect-label')"
              v-bind:select-label="$t('multiselect.selectedLabel')">
            </multiselect>
          </div>

          <div class="form-group col-md-4">
            <label>{{ $t('project.form.status') }}</label>
            <multiselect v-model="filter.companyStatus" track-by="item1" label="item2"
              :options="companyStatuses" :multiple="true" :taggable="false"
              v-bind:placeholder="$t('project.form.status')" 
              v-bind:deselect-label="$t('multiselect.deselect-label')"
              v-bind:select-label="$t('multiselect.selectedLabel')">
            </multiselect>
          </div>

          <div class="form-group col-md-4">
            <label>{{ $t('project.company.form.sectorOfActivity') }}</label>
            <multiselect v-model="filter.sector" track-by="item1" label="item2"
              :options="sectors" :multiple="true" :taggable="false"
              v-bind:placeholder="$t('project.company.form.sectorOfActivity')" 
              v-bind:deselect-label="$t('multiselect.deselect-label')"
              v-bind:select-label="$t('multiselect.selectedLabel')">
            </multiselect>
          </div>

        </div>
        <div class="row">

          <div class="form-group col-md-2"> 
            <label for="memberSince">{{ $t('dashboard.project.form.dateOfInvestissementFrom') }}</label>
            <moment-date-picker v-model="filter.dateOfInvestissementFrom" :required="false"></moment-date-picker>
          </div>

          <div class="form-group col-md-2">
            <label for="memberSince">{{ $t('dashboard.project.form.dateOfInvestissementTo') }}</label>
            <moment-date-picker v-model="filter.dateOfInvestissementTo" :required="false"></moment-date-picker>
          </div>

          <div class="form-group col-md-2">
              <label for="totalValueInput">{{ $t('dashboard.project.form.totalValueFrom') }}</label>
              <input v-model="filter.totalValueFrom" name="totalValueFrom" type="number" 
                  class="form-control" id="totalValueFrom" />
          </div>

          <div class="form-group col-md-2">
              <label for="totalValueInput">{{ $t('dashboard.project.form.totalValueTo') }}</label>
              <input v-model="filter.totalValueTo" name="totalValueTo" type="number" 
                  class="form-control" id="totalValueTo" />
          </div>

        </div>

      </div>
    </div>

    <div class="row" v-if="data.length == 0">
      
      <div class="col-xl-12 col-sm-6 mb-4" >
        <div :class="'card text-white o-hidden bg-secondary h-100'">
          <div class="card-body">
            <div class="card-body-icon">
              <i class="fa fa-spinner"></i>
            </div>
            <div class="mr-5">{{ $t("loading")}}</div>
          </div>
        </div>
      </div>
    
    </div>

    <div v-if="data.length != 0">
      <div class="row" >
        <div class="col-md-3" >

          <div :class="'card text-white o-hidden  mb-3 ' + (valueType == 'totalValue' ? 'bg-success' : 'bg-secondary') ">

            <div class="card-body">
              <div class="card-body-icon">
                <i class="fa fa-fw fa-money"></i>
              </div>
              <div class="mr-5"> 
                <div class="custom-control custom-radio">
                  <input type=radio v-model="valueType" name="valueType" id="valueType1" value='totalValue' class="custom-control-input" > 
                  <label class="custom-control-label" for="valueType1">{{ $t("dashboard.investment.data.title") }}</label>
                </div>
              </div>
            </div>
            
            <ul class="list-group list-group-flush text-dark">
               <li class="list-group-item"><span class="pull-right font-weight-bold">{{ totalValue  | moneyFormat }}</span> {{ $t("dashboard.investment.data.totalValue") }}</li>
               <li class="list-group-item"><span class="pull-right font-weight-bold">{{ totalQuantity }}</span> {{ $t("dashboard.investment.data.totalQuantity") }}</li>
               <li class="list-group-item"><span class="pull-right font-weight-bold">{{ totalEntreprises }}</span> {{ $t("dashboard.investment.data.totalEntreprises") }}</li>
            </ul>
          </div>

          <div :class="'card text-white o-hidden  mb-3 bg-success'">
            <ul class="list-group list-group-flush text-dark">
              <li class="list-group-item"><span class="pull-right font-weight-bold">{{ withPartner }} %</span> {{ $t("dashboard.investment.data.withPartner") }}</li>
            </ul>
          </div>

          <div :class="'card text-white o-hidden  mb-3 bg-success'">
            <div class="card-body">
              <div class="card-body-icon">
                <i class="fa fa-fw fa-money"></i>
              </div>
              <div class="mr-5"> {{ $t("dashboard.investment.processus.title") }}</div>
            </div>
            <ul class="list-group list-group-flush text-dark">
              <li class="list-group-item" v-for="process in processus">
                <!--span class="pull-right font-weight-bold">{{ process.value }}</span-->
                <span class="pull-right font-weight-bold" v-if="!isNaN(process.duration)">{{ process.duration }} jour(s)</span> 
                {{ process.text }} 
              </li>
            </ul>
          </div>
          
        </div>

        <div class="col-md-9" >

          <div class="row">

            <div class="col-md-3" v-for="(dataType, index) in dataTypes">
              <div :class="'card text-white o-hidden mb-3 ' + (valueType == dataType.valueType ? 'bg-primary' : 'bg-secondary')">

                <div class="card-body">
                  <div class="card-body-icon">
                    <i class="fa fa-fw fa-money"></i>
                  </div>
                  <div class="mr-5"> 
                    <div class="custom-control custom-radio">
                      <input type=radio name="valueType" v-model="valueType" :id="'valueType' + index+1" :value="dataType.valueType" class="custom-control-input" > 
                      <label class="custom-control-label" :for="'valueType' + index+1">{{ $t('dashboard.investment.' + dataType.valueType + '.title') }}</label>
                    </div>
                  </div>
                </div>
                
                <ul class="list-group list-group-flush text-dark">
                  <li class="list-group-item"><span class="pull-right font-weight-bold">{{ dataType.totalValue | moneyFormat }}</span> {{ $t('dashboard.investment.data.totalValue') }}</li>
                  <li class="list-group-item"><span class="pull-right font-weight-bold">{{ dataType.totalQuantity }}</span> {{ $t('dashboard.investment.data.totalQuantity') }}</li>
                  <li class="list-group-item"><span class="pull-right font-weight-bold">{{ dataType.totalEntreprise }}</span> {{ $t('dashboard.investment.data.totalEntreprises') }}</li>
                </ul>
              </div>
            </div>

          </div>

          <div class="row">
            
            <div class="col-md-6"  >

              <div class="card mb-3" v-if="typeQuantityData != null">
                <div class="card-header">
                  <i class="fa fa-pie-chart"></i> {{ $t("dashboard.investment.typeQuantityData") }} </div>
                  <pie-chart :chart-data="typeQuantityData.data" :options="typeQuantityData.options"></pie-chart>
              </div>

            </div>
            <div class="col-md-6"  >

              <div class="card mb-3" v-if="typeValueData != null">
                <div class="card-header">
                  <i class="fa fa-pie-chart"></i> {{ $t("dashboard.investment.typeValueData") }} </div>
                  <pie-chart :chart-data="typeValueData.data" :options="typeValueData.options"></pie-chart>
              </div>

            </div>
            <div class="col-md-6"  >

              <div class="card mb-3" v-if="regionValueData != null">
                <div class="card-header">
                  <i class="fa fa-pie-chart"></i> {{ $t("dashboard.investment.regionValueData") }} </div>
                  <pie-chart :chart-data="regionValueData.data" :options="regionValueData.options"></pie-chart>
              </div>

            </div>
            <div class="col-md-6"  >

              <div class="card mb-3" v-if="sectorValueData != null">
                <div class="card-header">
                  <i class="fa fa-pie-chart"></i> {{ $t("dashboard.investment.sectorValueData") }} </div>
                  <pie-chart :chart-data="sectorValueData.data" :options="sectorValueData.options"></pie-chart>
              </div>

            </div>

          </div>

          <div class="row">
            <div class="col-md-12"  >

              <div class="card mb-3" v-if="investmentProgressionData != null">
                <div class="card-header">
                  <i class="fa fa-pie-chart"></i> {{ $t("dashboard.investment.investmentProgressionData") }} </div>
                  <bar-chart :chart-data="investmentProgressionData.data" :options="investmentProgressionData.options"></bar-chart>
              </div>

            </div>

            <div class="col-md-12"  >

              <div class="card mb-3" v-if="investmentQttProgressionData != null">
                <div class="card-header">
                  <i class="fa fa-pie-chart"></i> {{ $t("dashboard.investment.investmentQttProgressionData") }} </div>
                  <bar-chart :chart-data="investmentQttProgressionData.data" :options="investmentQttProgressionData.options"></bar-chart>
              </div>

            </div>

          </div>

        </div>

      </div>
    </div>

  </div>
</template>

<script>
import ServiceFactory from '../../shared/service-clients/serviceClientFactory'
import {
  CompanyServiceClient,
  ProjectServiceClient,
  InvestmentServiceClient,
  AddressServiceClient,
  RoleServiceClient,
} from '../../shared/service-clients/service-clients'
import DashboardMixin from '../../shared/Mixin/DashboardMixin'

import palette from 'google-palette'

export default {
  name: 'InvestmentDashboard',
  mixins: [DashboardMixin],
  data() {
    return {
      valueType: 'totalValue',
      data: [],
      regions: [],
      investmentTypes: [],
      types: [],
      categorys: [],
      sectors: [],
      companyStatuses: [],
      investmentProcessTypes: [],
      filter: {
        region: [],
        investmentType: [],
        type: [],
        category: [],
        sector: [],
        companyStatus: [],
        dateOfInvestissementFrom: null,
        dateOfInvestissementTo: null,
        totalValueFrom: null,
        totalValueTo: null,
      },
    }
  },
  computed: {
    processus: function() {
      //let last = _.chain(this.filteredData)
      //  .filter(f => f.process != null && f.process.length > 0)
      //  .map(m => ({lastEvent: _.orderBy(m.process, 'dateOfProcess', 'desc')[0].type}))
      //  .value()

      return _.map(this.investmentProcessTypes, m => ({
        //value: _.filter(last, f => f.lastEvent == m.item1).length,
        duration: _.chain(this.filteredData)
          .flatMap('process')
          .map(im => ({type: im.type, duration: (im.lastProcess != null ? im.lastProcess : moment()).diff(im.dateOfProcess, 'days')}))
          .filter(f => f.type == m.item1)
          .meanBy('duration')
          .value()
          .toFixed(0),
        text: m.item2,
      }))
    },
    dataTypes: function() {
      return [
        {
          valueType: 'aqcAmount',
          totalValue: _.sumBy(this.filteredData, s => s.aqcAmount).toFixed(0),
          totalQuantity: _.sumBy(this.filteredData, s => s.aqcQuantity),
          totalEntreprise: _.chain(this.filteredData)
            .filter(f => f.aqcQuantity != null && f.aqcQuantity != 0)
            .groupBy('projectId')
            .map(m => m)
            .value().length,
        },
        {
          valueType: 'aqjAmount',
          totalValue: _.sumBy(this.filteredData, s => s.aqjAmount).toFixed(0),
          totalQuantity: _.sumBy(this.filteredData, s => s.aqjQuantity),
          totalEntreprise: _.chain(this.filteredData)
            .filter(f => f.aqjQuantity != null && f.aqjQuantity != 0)
            .groupBy('projectId')
            .map(m => m)
            .value().length,
        },
        {
          valueType: 'amountAngels',
          totalValue: _.sumBy(this.filteredData, s => s.amountAngels).toFixed(0),
          totalQuantity: _.sumBy(this.filteredData, s => s.quantityAngels),
          totalEntreprise: _.chain(this.filteredData)
            .filter(f => f.quantityAngels != null && f.quantityAngels != 0)
            .groupBy('projectId')
            .map(m => m)
            .value().length,
        },
        {
          valueType: 'amountPartners',
          totalValue: _.sumBy(this.filteredData, s => s.amountPartners).toFixed(0),
          totalQuantity: _.sumBy(this.filteredData, s => s.quantityPartners),
          totalEntreprise: _.chain(this.filteredData)
            .filter(f => f.quantityPartners != null && f.quantityPartners != 0)
            .groupBy('projectId')
            .map(m => m)
            .value().length,
        },
      ]
    },
    groupFormat: function() {
      return this.getDateTimeGroupFormat(this.filteredData, 'dateOfInvestissement')
    },
    investmentProgressionData: function() {
      if (this.filteredData.length > 0) {
        let data = _.chain(this.filteredData)
          .orderBy(o => o.dateOfInvestissement)
          .groupBy(o => moment(o.dateOfInvestissement).format(this.groupFormat))
          .map((items, key) => ({
            key: key,
            aqcAmount: _.sumBy(items, s => s.aqcAmount),
            aqjAmount: _.sumBy(items, s => s.aqjAmount),
            amountAngels: _.sumBy(items, s => s.amountAngels),
            amountPartners: _.sumBy(items, s => s.amountPartners),
          }))
          .value()

        if (this.valueType == 'totalValue') {
          return this.generateBarStackedChartFromData(
            data,
            'dashboard.investment',
            'aqcAmount',
            'aqjAmount',
            'amountAngels',
            'amountPartners'
          )
        } else {
          return this.generateBarStackedChartFromData(data, 'dashboard.investment', true, this.valueType)
        }
      } else {
        return this.emptyGraph
      }
    },
    investmentQttProgressionData: function() {
      if (this.filteredData.length > 0) {
        let data = _.chain(this.filteredData)
          .orderBy(o => o.dateOfInvestissement)
          .groupBy(o => moment(o.dateOfInvestissement).format(this.groupFormat))
          .map((items, key) => ({
            key: key,
            totalValue: items.length,
            aqcAmount: _.sumBy(items, s => (s.aqcAmount != null && s.aqcAmount != 0 ? 1 : 0)),
            aqjAmount: _.sumBy(items, s => (s.aqjAmount != null && s.aqjAmount != 0 ? 1 : 0)),
            amountAngels: _.sumBy(items, s => (s.amountAngels != null && s.amountAngels != 0 ? 1 : 0)),
            amountPartners: _.sumBy(items, s => (s.amountPartners != null && s.amountPartners != 0 ? 1 : 0)),
          }))
          .value()

        return this.generateBarStackedChartFromData(data, 'dashboard.investment', false, this.valueType)
      } else {
        return this.emptyGraph
      }
    },
    totalQuantity: function() {
      return this.filteredData.length
    },
    totalValue: function() {
      return _.sumBy(this.filteredData, 'totalValue').toFixed(0)
    },
    totalEntreprises: function() {
      return _.chain(this.filteredData)
        .groupBy('projectId')
        .map(m => m)
        .value().length
    },
    withPartner: function() {
      return (
        _.chain(this.filteredData).sumBy(s => (s.amountPartners != null && s.amountPartners != 0 ? 1 : 0)) *
        100 /
        this.totalQuantity
      ).toFixed(0)
    },
    typeQuantityData: function() {
      return this.getChartCountDataIfNotEmpty('investmentTypeText', this.valueType)
    },
    typeValueData: function() {
      return this.getChartSumData('investmentTypeText', this.valueType, true)
    },
    regionValueData: function() {
      return this.getChartSumData('regionText', this.valueType, true)
    },
    sectorValueData: function() {
      return this.getChartSumData('sectorOfActivityText', this.valueType, true)
    },
    filteredData: function() {
      let filtered = this.data

      filtered = this.filterPropertyByList(filtered, this.filter.region, 'region')
      filtered = this.filterPropertyByList(filtered, this.filter.investmentType, 'investmentType')
      filtered = this.filterPropertyByList(filtered, this.filter.type, 'type')
      filtered = this.filterPropertyByList(filtered, this.filter.category, 'category')
      filtered = this.filterPropertyByList(filtered, this.filter.sector, 'sectorOfActivity')
      filtered = this.filterPropertyByList(filtered, this.filter.companyStatus, 'companyStatus')

      filtered = this.filterPropertyByDateTo(filtered, this.filter.dateOfInvestissementTo, 'dateOfInvestissement')
      filtered = this.filterPropertyByDateFrom(filtered, this.filter.dateOfInvestissementFrom, 'dateOfInvestissement')

      filtered = this.filterPropertyByGreaterFloat(filtered, this.filter.totalValueTo, 'totalValue')
      filtered = this.filterPropertyByLesserFloat(filtered, this.filter.totalValueFrom, 'totalValue')

      return filtered
    },
  },
  methods: {
    fetchData: function() {
      let self = this
      // Workaround for the first time hit bug
      // TODO : Essayer de comprends qqs se passe...
      let pingService = ServiceFactory.create(RoleServiceClient)
      pingService.getAll(0, 1).then(rest => {
        let projectService = ServiceFactory.create(ProjectServiceClient)
        let companyService = ServiceFactory.create(CompanyServiceClient)
        let investmentService = ServiceFactory.create(InvestmentServiceClient)
        let addressService = ServiceFactory.create(AddressServiceClient)

        self.getDashBoardData(investmentService)
        self.getFilterData(addressService, investmentService, projectService, companyService)
      })
    },
    getFilterData: function(addressService, investmentService, projectService, companyService) {
      let self = this

      addressService.getRegions().then(res => {
        self.regions = res
      })
      investmentService.getTypes().then(res => {
        self.types = res
      })
      investmentService.getCategorys().then(res => {
        self.categorys = res
      })
      investmentService.getInvestmentDashboardType().then(res => {
        self.investmentTypes = res
      })
      projectService.getCompanyStatus().then(res => {
        self.companyStatuses = res
      })
      companyService.getSectorOfActivity().then(res => {
        self.sectors = res
      })
      investmentService.getInvestmentProcessType().then(res => {
        self.investmentProcessTypes = res
      })
    },
    getDashBoardData: function(service) {
      let self = this
      service
        .getDashboardData()
        .then(res => {
          self.data = res
          self.filterVisible = true
        })
        .catch(err => {
          console.log(err)
        })
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Investment.vue